import type { TenantConfig } from '@/types/TenantConfig'

export const kxtickets: TenantConfig = {
  logo: 'assets/kxtickets/static/logo-2.png',
  teaserImageSize: {
    width: 320,
    height: 308,
  },
  postCodeAsDiscountCode: {
    filter: 'UK',
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd, MMM Do, YYYY',
    },
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Jura:wght@700&family=Nunito+Sans:ital,wght@0,400;0,600;1,400;1,600&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      completedOrdersRoute: {
        title: '<span>Thank you</span> We look forward to your visit',
      },
    },
  },
}
